export const jobDescriptionPrompt = `Generate a comprehensive and professional job description for the following position. 

IMPORTANT FORMATTING RULES:
1. Use HTML formatting, NOT markdown
2. Use <strong> tags for bold text (NOT ** asterisks)
3. Use <br><br> for line breaks between sections
4. Use <ul> and <li> tags for bullet points
5. Structure the content with clear sections

CRITICAL - START OF CONTENT:
- DO NOT start with "Job Title:" or any job title heading at the very beginning
- DO NOT include "About the Company" as a heading at the very beginning
- Start directly with company information or job overview content (as paragraph text)

REQUIRED SECTION HEADINGS (include these with <strong> tags):
The description MUST include these sections with proper headings. CRITICAL: Each heading MUST be preceded by <br><br> to start on a new line:
- <br><br><strong>Job Overview</strong> (or similar) - MUST start with <br><br>, followed by content
- <br><br><strong>Key Responsibilities</strong> - MUST start with <br><br>, followed by bullet points (<ul><li>)
- <br><br><strong>Key Requirements</strong> (or "Requirements") - MUST start with <br><br>, followed by bullet points (<ul><li>)
- <br><br><strong>Why Join Us</strong> or <strong>Benefits</strong> (optional but recommended) - MUST start with <br><br>, followed by bullet points

IMPORTANT: Always use <br><br> before every section heading to ensure it starts on a new line with proper spacing.

The description should be well-structured, engaging, and cover:
1. Opening paragraph(s) with company information and introduction (NO heading for this section)
2. Job Overview section (WITH heading using <strong>)
3. Key Responsibilities section (WITH heading using <strong>, as bullet points)
4. Key Requirements section (WITH heading using <strong>, as bullet points)
5. Why Join Us / Benefits section (WITH heading using <strong>, as bullet points if applicable)

Keep it concise but comprehensive (around 300-500 words).

Return ONLY the HTML-formatted job description, no additional text or explanations.`;
